import { all, put, takeEvery, call } from 'redux-saga/effects'
import actions from "./actions";
import {getCustomerByWorkspaceIdApi} from "../../services/customer_workspace.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

export function* GET_CUSTOMER_BY_WORKSPACE_ID(action: {payload: string, type: string}) {
    try{
        const response: AxiosResponse<any> = yield call(
          getCustomerByWorkspaceIdApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_CUSTOMER_BY_WORKSPACE_ID,
                payload:response.data
            })
        }
    } catch (e) { logError("redux/customer_workspace/sagas/GET_CUSTOMER_BY_WORKSPACE_ID", e); }
}

export function* GET_WORKSPACE_BY_CUSTOMER_ID(action: {payload: string, type: string}) {
    try{
        const response: AxiosResponse<any> = yield call(
          getCustomerByWorkspaceIdApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_WORKSPACE_BY_CUSTOMER_ID,
                payload:response.data
            })
        }
    } catch (e) { logError("redux/customer_workspace/sagas/GET_WORKSPACE_BY_CUSTOMER_ID", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_CUSTOMER_BY_WORKSPACE_ID, GET_CUSTOMER_BY_WORKSPACE_ID),
        takeEvery(actions.GET_WORKSPACE_BY_CUSTOMER_ID, GET_WORKSPACE_BY_CUSTOMER_ID)
    ])
}

